import { Component, Input } from '@angular/core';
import { KeywordConfig } from '../../../../shared/models/keywords/keywords';

@Component({
  selector: 'app-components-shared-tracking-keywords',
  templateUrl: './tracking-keywords.component.html',
  styleUrls: ['../customer-campaign/customer-campaign.component.scss']
})
export class TrackingKeywordsComponent {
  @Input() customer: Boo.Objects.Customer;
  @Input() websiteUrls: Boo.Objects.WebsiteUrl[];
  @Input() trackingKeywords: Boo.Objects.WebsiteKeywordTracking[];
  @Input() archivedKeywords: Boo.Objects.ArchivedKeyword[];
  @Input() readOnlyReasons: string;
  @Input() restrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[];
  @Input() keywordConfig: KeywordConfig;

  get activeTrackingKeywordCount(): number {
    return this.trackingKeywords ? this.trackingKeywords.filter(trackingKeyword => trackingKeyword.IsActive).length : 0;
  }
}
